import { useCallback, useMemo } from 'react';
import {
    getServiceOrderSearch,
    getServiceOrderSearchMode,
    ServiceOrderSearchMode,
    serviceOrdersSlice,
    setServiceOrderSearch,
} from '../../../../reducers/serviceOrdersSlice';
import { useAppDispatch, useAppSelector } from '../../../../../../configuration/setup/hooks';
import { useIntl } from 'react-intl';
import { MultiModeSearch, SearchModeOption } from '../../../../sharedComponents/table/MultiModeSearch';

export const ServiceOrderSearch = () => {
    const intl = useIntl();
    const searchMode = useAppSelector(getServiceOrderSearchMode);
    const searchTerm = useAppSelector(getServiceOrderSearch);
    const dispatch = useAppDispatch();

    const selectOptions: SearchModeOption<ServiceOrderSearchMode>[] = useMemo(
        () =>
            Object.values(ServiceOrderSearchMode).map((mode) => ({
                id: mode,
                label: intl.formatMessage({
                    id: `outboundOrderBook.serviceOrder.table.toolbar.search.mode.${mode}.label`,
                }),
                placeholder: intl.formatMessage({
                    id: `outboundOrderBook.serviceOrder.table.toolbar.search.mode.${mode}.placeholder`,
                }),
            })),
        [intl],
    );

    const onSearchModeChange = useCallback(
        (mode: ServiceOrderSearchMode) => dispatch(serviceOrdersSlice.actions.setSearchMode(mode)),
        [dispatch],
    );

    const onSearchTermChange = useCallback(
        (newValue: string) => dispatch(setServiceOrderSearch({ value: newValue })),
        [dispatch],
    );

    const onClear = useCallback(() => dispatch(setServiceOrderSearch({ value: '', immediate: true })), [dispatch]);

    const onEnterPressed = useCallback(
        () => dispatch(setServiceOrderSearch({ value: searchTerm, immediate: true })),
        [searchTerm, dispatch],
    );

    return (
        <MultiModeSearch
            modes={selectOptions}
            selectedMode={searchMode}
            onSearchModeChange={onSearchModeChange}
            searchTerm={searchTerm}
            onSearchTermChange={onSearchTermChange}
            onClear={onClear}
            onEnterPressed={onEnterPressed}
        />
    );
};
